// Copyright (c) 2016 Deere & Company

import {updatePinSearchResults} from './pin-search';
import {updatePipSearchResults} from './pip-search';

export const updateSearchResults = (query, key) =>
    dispatch => {

        const map = {
            PIN: updatePinSearchResults,
            PIP: updatePipSearchResults
        };

        dispatch(map[key](query, key));

        dispatch({
            key,
            type: 'UPDATE_PIP_SEARCH_BY'
        });

    };



// WEBPACK FOOTER //
// ./src/pip/pip-search/action-creators/select-search-by.js